import { S as u, q as m } from "./stale.constant.De1PuSBj.js";
import { useQuery as p, useMutation as d } from "@tanstack/react-query";
import { a as C } from "./api.DHdhNbok.js";
import { saveTimestampToLocalStorage as y } from "../utils/storage/index.js";
const r = {
  relationships: "api/accounts/relationships"
}, c = async (t, s, o) => {
  y();
  const a = await C[t](s, o);
  if (!a.ok) throw new Error(await a.json());
  return a.json();
}, g = (t, s = !0) => `${r.relationships}?${new URLSearchParams({ [t]: String(s) })}`, e = (t, s) => async ({ flag: o, relationship: a, connectedRelUsername: i }) => c(t, g(s, o), { ...a, connectedRelUsername: i }), h = async () => c("get", r.relationships), l = e("post", "setAsEmergencyContact"), E = e("put", "setAsEmergencyContact"), A = e("post", "setAsGuardian"), G = e("put", "setAsGuardian"), U = (t) => p({
  queryKey: m.userRelationships,
  queryFn: h,
  staleTime: u,
  select: (s) => s.data,
  enabled: t ?? !0
}), n = (t, s) => d({
  ...s,
  mutationFn: t
}), f = (t) => n(l, t), w = (t) => n(E, t), b = (t) => n(A, t), L = (t) => n(G, t);
export {
  f as a,
  b,
  L as c,
  w as d,
  U as u
};
